<template lang="pug">
ul.nav(:class='navClasses')
  li
    router-link.dropdown-toggle(v-if='checkLogin', to='/', data-toggle='dropdown')
      //i.material-icons dashboard
      i.fas.fa-home
      p.hidden-lg.hidden-md Dashboard
  
  li.dropdown(v-if='checkLogin', :class='{ open : isDropdownOpened }', v-on-clickaway='closeDropdown')
    a.dropdown-toggle(href='#', data-toggle='dropdown', @click.prevent='openDropdown')
      //i.material-icons notifications
      i.fas.fa-bell
      span.notification 98
      p.hidden-lg.hidden-md Notifications
    ul.dropdown-menu
      li
        a(href='#') Mike John responded to your email
      li
        a(href='#') You have 5 new tasks
      li
        a(href='#') You're now friend with Andrew
      li
        a(href='#') Another Notification
      li
        a(href='#') Another One

  li.dropdown(v-if='checkLogin', :class='{ open : isProfileDropdownOpened }', v-on-clickaway='closeProfileDropdown')
    a.dropdown-toggle(href='#', data-toggle='dropdown', @click.prevent='openProfileDropdown')
      //i.material-icons person
      i.fas.fa-user
      p.hidden-lg.hidden-md Profile
      span {{this.$user.email || 'Welcome !'}}
    ul.dropdown-menu(v-if='checkLogin')
      li
        a(href='#') {{this.$user.email}}
      li
        a(href='#') {{ $t('My Profile') }}
      li
        a(href='#', @click='logout()') {{ $t('Logout') }}
</template>
<script>

import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'navbar-right',
  mixins: [ clickaway ],
  props: {
    mobile: Boolean
  },
  data() {
    return {
      isDropdownOpened: false,
      isProfileDropdownOpened: false
    }
  },
  computed: {
    navClasses() {
      return this.mobile ? ['nav-mobile-menu'] : ['navbar-nav', 'navbar-right']
    },
    checkLogin() {
      return this.$store.state.isLoggedIn
    }
  },
  methods: {
    logout() {
      this.closeProfileDropdown()
      this.$user.logout()
    },

    openDropdown() {
      this.isDropdownOpened = !this.isDropdownOpened
    },
    closeDropdown() {
      if (this.isDropdownOpened) {
        this.isDropdownOpened = false
      }
    },
    openProfileDropdown() {
      this.isProfileDropdownOpened = !this.isProfileDropdownOpened
    },
    closeProfileDropdown() {
      if (this.isProfileDropdownOpened) {
        this.isProfileDropdownOpened = false
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// navbar-right.vue?438b5dcc